import { Alert, AlertIcon, AlertDescription } from '@/ui';

interface NotificationProps {
  children: React.ReactNode;
  status?: 'info' | 'warning' | 'error';
}

export const Notification = ({
  children,
  status = 'info',
}: NotificationProps) => {
  const colors = {
    info: {
      bg: '#E6F3FF', // Light blue background
      text: '#2B6CB0', // Dark blue text
      icon: '#3182CE', // Blue icon
    },
    warning: {
      bg: 'brand.40', // Light pink background
      text: 'brand.500', // Dark pink text
      icon: 'brand.500', // Pink icon
    },
    error: {
      bg: '#FEF5F5', // Light red background
      text: '#C53030', // Dark red text
      icon: '#E53E3E', // Red icon
    },
  };

  const currentColors = colors[status];

  return (
    <Alert
      backgroundColor="brand.100"
      bg={currentColors.bg}
      border="transparent"
      borderRadius="md"
      borderWidth="1px"
      color={currentColors.text}
      status={status}
      variant="subtle"
    >
      <AlertIcon color={currentColors.icon} />
      <AlertDescription fontSize="sm" lineHeight="1.4">
        {children}
      </AlertDescription>
    </Alert>
  );
};
